import React from 'react'

import { useOperatorAuth } from '@contexts/operator/OperatorAuthContext'
import { useOperatorNotification } from '@contexts/operator/OperatorNotificationContext'
import OrderShow from '@shared/orders/OrderShow'
import { useLoaderData } from 'react-router-dom'

import { operatorApiFetch } from '@services/operator/apiService'
import { orderService } from '@services/operator/orderService'
import { shipmentService } from '@services/operator/shipmentService'
import { thirdPartyApiLogService } from '@services/operator/thirdPartyApiLogService'
import { webhookDeliveryService } from '@services/operator/webhookDeliveryService'
import { partnerApiLogService } from '@services/operator/partnerApiLogService'
import { valueAddedServiceService } from '@services/operator/valueAddedServiceService'
import { contactAddressService } from '@services/operator/contactAddressService'

import operatorCable from '@/lib/operatorCable'

const OperatorOrderShow: React.FC = () => {
  const order = useLoaderData()
  const { addJob } = useOperatorNotification()
  const { operator } = useOperatorAuth()

  return (
    <OrderShow
      role="operator"
      order={order}
      orderService={orderService}
      shipmentService={shipmentService}
      thirdPartyApiLogService={thirdPartyApiLogService}
      webhookDeliveryService={webhookDeliveryService}
      partnerApiLogService={partnerApiLogService}
      valueAddedServiceService={valueAddedServiceService}
      cableManager={operatorCable}
      addJob={addJob}
      organizationId={operator?.organization_id}
      currentWarehouse={operator?.warehouse}
      contactAddressService={contactAddressService}
    />
  )
}

export default OperatorOrderShow
